import React from "react";
import {Router, Redirect, Switch} from "react-router-dom";
import HubList from "./components/HubList";
import Hub from "./components/Hub";
import History from './components/History'
import PrivateRoute from "./components/PrivateRoute";
import {useAuth0} from "./auth/sso";
import Loading from "./components/Loading";
import NavBar from "./components/NavBar";
import queryString from 'query-string';
import HubMetricsExport from "./components/HubMetricsExport";
import Snackbar from "./components/Snackbar";

function App() {
    const redirectToHub = (hubId) => {
        History.push(`/hubs/${hubId}`);
    };

    const {loading} = useAuth0();

    if (loading) {
        return <Loading/>;
    }

    return (
        <Router history={History}>
            <div>
                <NavBar/>
                <Snackbar/>
                <Switch>
                    <PrivateRoute path="/" exact component={() => (<Redirect exact to="/hubs"/>)}/>

                    <PrivateRoute path="/hubs" exact
                                  component={() => (
                                      <HubList selectHub={redirectToHub}/>
                                  )}/>

                    <PrivateRoute path="/hubs/:hubId" exact component={(props) => {
                        const {hubId} = props.match.params;

                        return (
                            <Hub hubId={hubId}/>
                        );
                    }}/>

                    <PrivateRoute path="/hubs/:hubId/metrics/export" exact component={(props) => {
                        const {hubId} = props.match.params;
                        const {from, to} = queryString.parse(props.location.search);

                        return (
                            <HubMetricsExport hubId={hubId} from={from} to={to}/>
                        );
                    }}/>
                </Switch>
            </div>
        </Router>
    );
}

export default App;